import { action, makeObservable, observable } from "mobx";

class MailConfirmationStore {
  modalVisible = false;
  userEmail: string | null = null;

  constructor() {
    makeObservable(this, {
      modalVisible: observable,
      userEmail: observable,
      setUserEmail: action,
    });
  }

  getModalIsVisible() {
    return this.modalVisible;
  }

  setModalVisible(value: boolean) {
    this.modalVisible = value;
  }

  setUserEmail(userEmail: string | null) {
    this.userEmail = userEmail;
  }
}

const mailConfirmationStore = new MailConfirmationStore();
export default mailConfirmationStore;
